// extracted by mini-css-extract-plugin
export default {"client-profile-content":"client-profile-camera-settings_client-profile-content__OW85X"};